export type Alias = { name: string; altName: string };

export const GTP_ALIASES: Alias[] = [
  { name: "Crash medium (choke)", altName: "Crash medium (hit)" },
  { name: "Hi-Hat (open 2)", altName: "Hi-Hat (open)" },
  { name: "Hi-Hat (open 3)", altName: "Hi-Hat (open)" },
  { name: "Hi-Hat (half 2)", altName: "Hi-Hat (half)" },
  { name: "Hi-Hat (half 3)", altName: "Hi-Hat (half)" },
  { name: "Hi-Hat (closed 2)", altName: "Hi-Hat (closed)" },
  { name: "Mini Ride Bell 1", altName: "Ride (bell)" },
  { name: "Mini Ride Bell 2", altName: "Ride (bell)" },
  { name: "Ride (bell 2)", altName: "Ride (bell)" },
  { name: "Ride (hit)", altName: "Ride (edge)" },
  { name: "Double Stack", altName: "Ride (choke)" },
  { name: "Stick", altName: "Snare (side stick)" },
  { name: "Snare (hit 2)", altName: "Snare (rim shot)" }
];

export const GGD_P5_ALIASES: Alias[] = [
  { name: "Mid Tom (hit)", altName: "Low Tom (hit)" },
  { name: "Tambourine (hit)", altName: "Splash (choke)" },
  { name: "Low Floor Tom (hit)", altName: "Low Tom (hit)" },
  { name: "High Floor Tom (hit)", altName: "High Tom (hit)" },
  { name: "Ride (middle)", altName: "Ride (hit)"},
  { name: "Ride (edge)", altName: "Ride (hit)"}
];
